import { createFileRoute, Outlet } from "@tanstack/react-router";
export const Route = createFileRoute("/_site/gift-cards/$brand")({ component: GiftCardBrandLayout });
function GiftCardBrandLayout() { return <Outlet />; }
